///
/// EarthBrowser
///
/// Created by Matt Giger
/// Copyright (c) 2025 Geodata Labs
///

import type { EarthBrowserContext } from "@/earthbrowser/EarthBrowserContext"
import { TapGestureRecognizer } from "@stovokor/gestures/TapGestureRecognizer"
import type { EarthCameraState } from "../EarthCameraState"

/**
 * EarthSingleTapHandler - Single tap gesture recognizer for Earth
 *
 * Single tap logs the geographic location (can be extended for selection).
 */
export class EarthSingleTapHandler extends TapGestureRecognizer {
	private context: EarthBrowserContext

	constructor(context: EarthBrowserContext, doubleTapRecognizer?: TapGestureRecognizer) {
		super({
			numberOfTapsRequired: 1,
			maxMovement: 10,
			maxDuration: 300,
			maximumTouches: 1, // Fail immediately if second finger touches (for pinch-to-zoom)
			requireToFail: doubleTapRecognizer ? [doubleTapRecognizer] : []

		})
		this.context = context
		this.priority = 10

		this.onGesture(() => {
			this.context.focusManager.requestFocus(this.owner!, {
				preserveCurrentState: true
			})
		})
	}
}

/**
 * EarthDoubleTapHandler - Double tap gesture recognizer for Earth
 *
 * Double tap zooms in to the tapped location.
 */
export class EarthDoubleTapHandler extends TapGestureRecognizer {
	private context: EarthBrowserContext
	private cameraState: EarthCameraState

	constructor(context: EarthBrowserContext, cameraState: EarthCameraState) {
		super({
			numberOfTapsRequired: 2,
			maxMovement: 20,
			maxDuration: 300,
			maxIntervalBetweenTaps: 350,
			maximumTouches: 1 // Fail if second finger touches (for pinch-to-zoom)
		})
		this.context = context
		this.cameraState = cameraState
		this.priority = 20

		this.onGesture((data) => {
			if(!this.owner) return;

			// this.context.logger.log("EarthDoubleTapHandler end")

			this.context.focusManager.requestFocus(this.owner, {
				preserveCurrentState: true
			})

			this.cameraState.syncFromCamera()

			if (data.ownerHits && data.ownerHits.length > 0) {
				// this.context.logger.log("EarthDoubleTapHandler zooming to point", data.ownerHits[0].hitPoint)
				this.cameraState.zoomToPoint(data.ownerHits[0].hitPoint)
			}
		})
	}
}
